export const robotsRedirectConfig: Record<
  string,
  () => Promise<{
    default: {
      head: string;
      body: string;
    };
  }>
> = {
  "/": async () => await import("./pages/homePage"),
  "/keno": async () => await import("./pages/keno"),
  "/crash": async () => await import("./pages/crash"),
  "/limbo": async () => await import("./pages/limbo"),
  "/mines": async () => await import("./pages/mines"),
  "/towers": async () => await import("./pages/towers"),
  "/plinko": async () => await import("./pages/plinko"),
  "/hash-dice": async () => await import("./pages/dice"),
  "/diamonds": async () => await import("./pages/diamonds"),
  "/video-poker": async () => await import("./pages/poker"),
  "/roulette": async () => await import("./pages/roulette"),
  "/blackjack": async () => await import("./pages/blackjack"),
  // "/slot-games": async () => await import("./pages/slotGames"),
  "/feyorra-utilities": async () => await import("./pages/feyorraUtilities"),
  "/bonus": async () => await import("./pages/bonus"),
  "/fortune-quest": async () => await import("./pages/fortune"),
  "/affiliate": async () => await import("./pages/affiliate"),
  "/lottery": async () => await import("./pages/lottery"),
  "/lottery/my-winnings": async () => await import("./pages/lotteryWinnings"),
  "/lottery/history": async () => await import("./pages/lotteryHistory"),
};
